import * as getters from "../../baseQuestion/staticDDL/store/getters";
import * as mutations from "../../baseQuestion/staticDDL/store/mutations";
import * as actions from "../../baseQuestion/staticDDL/store/actions";
import { state as base_state } from "../../baseQuestion/staticDDL/store/state";

function state() {
	return Object.assign(
		{
			multi_field_parent: "q_college",
			options: [
				{
					value: "F",
					text: "Full Time"
				},
				{
					value: "P",
					text: "Part Time"
				}
			]
		},
		base_state()
	);
}

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions
};
